import {
  ADD_CONSTITUENT_AFFINITY,
  ADD_CONSTITUENT_RELATIONSHIP,
  ADD_NOTE,
  CREATE_CONSTITUENT_DEGREE,
  CREATE_CONSTITUENT_POSITION,
  DELETE_ALL_CONSTITUENT_EXPERIENCES,
  DELETE_CONSTITUENT,
  DELETE_CONSTITUENT_AFFINITY,
  DELETE_CONSTITUENT_AVATAR,
  DELETE_CONSTITUENT_DEGREE,
  DELETE_CONSTITUENT_POSITION,
  DELETE_CONSTITUENT_RELATIONSHIP,
  DELETE_NOTE,
  EDIT_NOTE,
  FETCH_NOTES,
  receiveCurrentConstituent,
  receiveDeletedNote,
  receiveEditedNote,
  receiveNote,
  receiveNotes,
  SAVE_CONSTITUENT_AVATAR,
  UPDATE_CONSTITUENT,
  UPDATE_CONSTITUENT_DEGREE,
  UPDATE_CONSTITUENT_POSITION,
} from "@/components/profile/admin/ducks/Actions"
import {
  addConstituentAffinity,
  addConstituentRelationship,
  addNotes,
  apiDeleteAllConstituentExperiences,
  createConstituentDegree,
  createConstituentPosition,
  deleteConstituent,
  deleteConstituentAffinity,
  deleteConstituentAvatar,
  deleteConstituentDegree,
  deleteConstituentPosition,
  deleteConstituentRelationship,
  deleteNote,
  editNote,
  fetchNotes,
  saveConstituentAvatar,
  updateConstituent,
  updateConstituentDegree,
  updateConstituentPosition,
} from "@/components/profile/admin/ducks/AJAX"
import { receiveUpdateUserConstituent } from "@/components/profile/ducks/Actions"
import { refetchSearch } from "@/components/search/ducks/Actions"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const receiveCurrentConstituentSuccess = (refetch, cb) => (response) => {
    dispatch(receiveCurrentConstituent(response.constituent))
    if (refetch) {
      dispatch(refetchSearch())
    }
    if (cb) {
      cb()
    }
  }

  const receiveDeleteConstituentSuccess = (cb) => () => {
    dispatch(refetchSearch(cb))
  }

  const recieveAddGroupRelationshipSuccess = (cb) => (response) => {
    dispatch(receiveCurrentConstituent(response.constituent))
    if (response.currentConstituent) {
      dispatch(receiveUpdateUserConstituent(response.currentConstituent))
    }
    dispatch(refetchSearch())
    if (cb) {
      cb()
    }
  }

  switch (action.type) {
    case DELETE_CONSTITUENT:
      deleteConstituent(
        action.constituentId,
        receiveDeleteConstituentSuccess(action.success),
        action.error,
      )
      return next(action)

    case DELETE_ALL_CONSTITUENT_EXPERIENCES:
      apiDeleteAllConstituentExperiences(
        action.experienceType,
        action.constituentId,
        receiveCurrentConstituentSuccess(true),
        action.error,
      )
      return next(action)

    case UPDATE_CONSTITUENT:
      updateConstituent(
        action.constituent,
        receiveCurrentConstituentSuccess(true, action.success),
        action.error,
      )
      return next(action)

    case CREATE_CONSTITUENT_DEGREE:
      createConstituentDegree(`admin/memberDegree/${action.constituentId}`)(
        action.degree,
        receiveCurrentConstituentSuccess(true, action.success),
        action.error,
      )
      return next(action)

    case UPDATE_CONSTITUENT_DEGREE:
      updateConstituentDegree(`admin/memberDegree/${action.constituentId}`)(
        action.degree,
        receiveCurrentConstituentSuccess(true, action.success),
        action.error,
      )
      return next(action)

    case DELETE_CONSTITUENT_DEGREE:
      deleteConstituentDegree(`admin/memberDegree/${action.constituentId}`)(
        action.degree,
        receiveCurrentConstituentSuccess(true, action.success),
        action.error,
      )
      return next(action)

    case CREATE_CONSTITUENT_POSITION:
      createConstituentPosition(`admin/memberPosition/${action.constituentId}`)(
        action.position,
        receiveCurrentConstituentSuccess(true, action.success),
        action.error,
      )
      return next(action)

    case UPDATE_CONSTITUENT_POSITION:
      updateConstituentPosition(`admin/memberPosition/${action.constituentId}`)(
        action.position,
        receiveCurrentConstituentSuccess(true, action.success),
        action.error,
      )
      return next(action)

    case ADD_CONSTITUENT_AFFINITY:
      addConstituentAffinity(
        action.affinity,
        action.constituentId,
        recieveAddGroupRelationshipSuccess(action.success),
        action.error,
      )
      return next(action)

    case DELETE_CONSTITUENT_AFFINITY:
      deleteConstituentAffinity(
        action.affinityId,
        action.constituentId,
        recieveAddGroupRelationshipSuccess(),
        action.error,
      )
      return next(action)

    case ADD_CONSTITUENT_RELATIONSHIP:
      addConstituentRelationship(
        action.relationship,
        action.constituentId,
        recieveAddGroupRelationshipSuccess(action.success),
        action.error,
      )
      return next(action)

    case DELETE_CONSTITUENT_RELATIONSHIP:
      deleteConstituentRelationship(
        action.relationshipId,
        action.constituentId,
        recieveAddGroupRelationshipSuccess(),
        action.error,
      )
      return next(action)

    case SAVE_CONSTITUENT_AVATAR:
      saveConstituentAvatar(
        action.img,
        action.constituentId,
        receiveCurrentConstituentSuccess(true),
        action.error,
      )
      return next(action)

    case DELETE_CONSTITUENT_AVATAR:
      deleteConstituentAvatar(
        action.constituentId,
        receiveCurrentConstituentSuccess(true),
        action.error,
      )
      return next(action)

    case DELETE_CONSTITUENT_POSITION:
      deleteConstituentPosition(`admin/memberPosition/${action.constituentId}`)(
        action.position,
        receiveCurrentConstituentSuccess(true, action.success),
        action.error,
      )
      return next(action)

    case FETCH_NOTES:
      fetchNotes(action.constituentId, receiveNotes)
      return next(action)

    case ADD_NOTE:
      addNotes(action.payload, (resp) => {
        dispatch(receiveNote(resp))
        dispatch(refetchSearch())
      })
      return next(action)

    case EDIT_NOTE:
      editNote(action.payload, (resp) => {
        dispatch(receiveEditedNote(resp))
        dispatch(refetchSearch())
      })
      return next(action)

    case DELETE_NOTE:
      deleteNote(action.payload, (resp) => {
        dispatch(receiveDeletedNote(resp))
        dispatch(refetchSearch())
      })
      return next(action)
    default:
      return next(action)
  }
}
